import React, { useState } from 'react';
import { getAnalytics, getAttendance,getQueryInfo,getTransformerInfo,getEnrichmentInfo, getProductInfo, getDistinctNames, getDistinctOutlets, getGenericObjectData, getInvoiceCollection, getOutletData, getProductDataUsingSkucode, getProductMetadata, getUserData, getSchemeDef, getSchemeCal, getSchemeProBif, getSchemeMustBuy, getSchemeOutBif, getDeliveryPJP, getStockData } from '../../services/dataValidationService';
import Data from './data/Data';
import './DataValidation.css'
import CalenderFilter from './calenderFilter/CalenderFilter';
import ListDropdown from './listDropdown/ListDropdown';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import TablePagination from '@mui/material/TablePagination';

const DataValidation = () => {
    const NoDataDisplay = (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '512px' // This is equivalent to h-64 in Tailwind
      }}>
        <div style={{
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          padding: '24px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <p style={{
            fontSize: '16px',
            color: '#666',
            margin: 0
          }}>
            No response available
          </p>
        </div>
      </div>
    );
  const [loginId, setLoginId] = useState('');
  const [userData, setUserData] = useState<any[] | null>(null);
  const [stockData, setStockData] = useState<any[] | null>(null);
  const [outletData, setOutletData] = useState<any[] | string[] | null>(null);
  const [productData, setProductData] = useState<any[] | null>(null);
  const [productInfoData, setProductInfoData] = useState<any[] | null>(null);
  const [schemeDefData, setschemeDefData] = useState<any[] | null>(null);
  const [schemeCalData, setschemeCalData] = useState<any[] | null>(null);
  const [schemeMustBuyData, setschemeMustBuyData] = useState<any[] | null>(null);
  const [schemeOutBifData, setschemeOutBifData] = useState<any[] | null>(null);
  const [schemeProBifData, setschemeProBifData] = useState<any[] | null>(null);
const [deliveryPjp, setdeliveryPjP] = useState<any[] | null>(null);
  const [productCode, setProductCode] = useState('');
  const [pricingData, setPricingData] = useState<any[] | null>(null);
  const [analyticsData, setAnalyticsData] = useState<any[] | null>(null);
  const [attendanceData, setAttendanceData] = useState<any[] | null>([]);
  const [invoiceCollection, setInvoiceCollection] = useState<any[] | null>(null);
  const [ordersData, setOrdersData] = useState<any[] | null>(null);
  const [salesData, setSalesData] = useState<any[] | null>(null);
  const [enrichmentInfo, setEnrichmentInfo] = useState<any>(null);
  const [transformerInfo, setTransformerInfo] = useState<any>(null);
  const [queryInfo, setQueryInfo] = useState<any>(null)
  const [outletDetails, setOutletDetails] = useState<any[] | null>(null);
  const [currentView, setCurrentView] = useState(null);

  // Separate anchor elements for orders and sales
  const [ordersAnchorEl, setOrdersAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [salesAnchorEl, setSalesAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [anchorElList, setAnchorElList] = React.useState<HTMLButtonElement | null>(null);
  const [anchorElListGenericObject, setAnchorElListGenericObject] = React.useState<HTMLButtonElement | null>(null);
  const [orderDetails, setOrderDetails] = useState<any>(null);
  const [schemeId, setSchemeId] = useState("");
  const [genericObjectData, setGenericObjectData] = useState< any[] |string[] | null>(null);
  const [genericObjectDetails, setGenericObjectDetails] = useState<any[] | null>(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [count, setCount] = useState(0);

  // Open states for different popovers
  const ordersOpen = Boolean(ordersAnchorEl);
  const salesOpen = Boolean(salesAnchorEl);
  const listOpen = Boolean(anchorElList);
  const genericObjectOpen = Boolean(anchorElListGenericObject);

  const open = Boolean(anchorElList || anchorElListGenericObject);
  const id = open ? 'simple-popover' : undefined;

  const handleChangePage = (event: unknown, newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const resetPageNoAndSetCount = async (count: number) => {
    setCount(count);
  }

  const handleLoginIdChange = (e: any) => {
    setLoginId(e.target.value);
  };

  const handleProductCodeChange = (e: any) => {
    setProductCode(e.target.value);
  };

  const handleSchemeIdChange = (e: any) => {
    setSchemeId(e.target.value);
  };

  const fetchUserData = async () => {
    try {
      const response = await getUserData(loginId);
      setUserData(response.features);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  const fetchOutletData = async () => {
    try {
      const outletResponse = await getDistinctOutlets(loginId);
      setOutletData(outletResponse.features);
    } catch (error) {
      console.error('Error fetching outlet data:', error);
    }
  };

  const fetchDistinctGenericObjectNames = async () => {
    try {
      const distinctNames = await getDistinctNames();
      const namesArray = distinctNames.features.map((name: any) => name.name);
      setGenericObjectData(namesArray);
    } catch (error) {
      console.error('Error fetching outlet data:', error);
    }
  };

  const fetchEnrichmentInfo = async () => {
      try {
        const response = await getEnrichmentInfo();
        setEnrichmentInfo(response.features);
      } catch (error) {
        console.error('Error fetching enrichment data:', error);
      }
    };

const fetchTransformerInfo = async () => {
      try {
        const response = await getTransformerInfo();
        setTransformerInfo(response.features);
      } catch (error) {
        console.error('Error fetching transformer data:', error);
      }
    };
const fetchQueryInfo = async () => {
      try {
        const response = await getQueryInfo();
        setQueryInfo(response.features);
      } catch (error) {
        console.error('Error fetching query data:', error);
      }
    };



  const handleOutletSelect = async (code: string) => {
    try {
      const response = await getOutletData(code);
      setOutletDetails(response.features);
    } catch (error) {
      console.error('Error fetching outlet details:', error);
    }
  };

  const handleGenericObjectSelect = async (name: string) => {
    try {
      const response = await getGenericObjectData(name);
      setGenericObjectDetails(response.features);
    } catch (error) {
      console.error('Error fetching generic object data:', error);
    }
  };

  const fetchProductData = async () => {
    try {
      const response = await getProductDataUsingSkucode(productCode);
      setProductData(response.features);
    } catch (error) {
      console.error('Error fetching product data:', error);
    }
  };

  const fetchSchemesDef = async () => {
    try {
      const response = await getSchemeDef(schemeId);
      setschemeDefData(response.features);
    } catch (error) {
      console.error('Error fetching schemes data:', error);
    }
  }

  const fetchSchemesCal = async () => {
    try {
      const response = await getSchemeCal(schemeId);
      setschemeCalData(response.features);
    } catch (error) {
      console.error('Error fetching schemes data:', error);
    }
  }

  const fetchSchemesMustBuy = async () => {
    try {
      const response = await getSchemeMustBuy(schemeId);
      setschemeMustBuyData(response.features);
    } catch (error) {
      console.error('Error fetching schemes data:', error);
    }
  }

  const fetchSchemesOutBif = async () => {
    try {
      const response = await getSchemeOutBif(schemeId);
      setschemeOutBifData(response.features);
    } catch (error) {
      console.error('Error fetching schemes data:', error);
    }
  }

  const fetchSchemesProBif = async () => {
    try {
      const response = await getSchemeProBif(schemeId);
      setschemeProBifData(response.features);
    } catch (error) {
      console.error('Error fetching schemes data:', error);
    }
  }

  const fetchProductMetadata = async () => {
    try {
      const response = await getProductMetadata(productCode);
      setPricingData(response.features);
    } catch (error) {
      console.error('Error fetching pricing data:', error);
    }
  };

  const fetchStockData = async () => {
    try {
      const response = await getStockData(productCode);
      setStockData(response.features);
    } catch (error) {
      console.error('Error fetching stock data:', error);
    }
  };

  const fetchProductInfoData = async () => {
    try {
      const response = await getProductInfo(loginId);
      setProductInfoData(response.features);
    } catch (error) {
      console.error('Error fetching product info data:', error);
    }
  };

  const fetchAnalytics = async () => {
    try {
      const response = await getAnalytics(loginId);
      setAnalyticsData(response.features);
    } catch (error) {
      console.error('Error fetching analytics data:', error);
    }
  };

  const fetchAttendance = async () => {
    try {
      const response = await getAttendance(loginId);
      setAttendanceData(response.features);
    } catch (error) {
      console.error('Error fetching attendance data:', error);
    }
  };

  const fetchInvoiceCollection = async () => {
    try {
      const response = await getInvoiceCollection(loginId);
      setInvoiceCollection(response.features);
    } catch (error) {
      console.error('Error fetching invoice data:', error);
    }
  }

  const fetchdeliveryPJP = async () => {
    try {
      const response = await getDeliveryPJP(loginId);
      setdeliveryPjP(response.features);
    } catch (error) {
      console.error('Error fetching delivery PJP data:', error);
    }
  }

  const toggleOrdersSection = (event: React.MouseEvent<HTMLButtonElement>) => {
    setSalesAnchorEl(null); // Close sales calendar if open
    setOrdersAnchorEl(event.currentTarget);
  }

  const toggleSalesSection = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOrdersAnchorEl(null); // Close orders calendar if open
    setSalesAnchorEl(event.currentTarget);
  }

  const toggleOutletSection = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElList(event.currentTarget);
    fetchOutletData();
  }

  const toggleGenericObject = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElListGenericObject(event.currentTarget);
    fetchDistinctGenericObjectNames();
  }

  const fetchDataSection = (title: any, fetchFunction: any, data: any) => (
    <div>
      <button className='fetchDataButtons'
        aria-describedby={id}
        onClick={
          (event) => {
            fetchFunction(event);
            setCurrentView(title);
            setOrderDetails(null);
          }}>
        {`Get ${title}`}
      </button>
    </div>
  );

  const downloadExcel = async (data: null) => {
    const jsonData = data !== null ? data : [];
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    worksheet.columns = Object.keys(jsonData[0]).map(key => ({ header: key, key }));

    jsonData.forEach(json => {
      worksheet.addRow(json);
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, currentView + ' data.xlsx');
  };

  const expandJsonView = async (index: number | string, fieldName: string, data: any) => {
    if (data) {
      if (typeof index === 'string' && !Array.isArray(data)) {
        const result: { [key: string]: any } = {};
        result[index] = data[index];
        setOrderDetails(result);
      } else {
        const dataArray = Array.isArray(data) ? data : Object.values(data);
        const numericIndex = typeof index === 'string' ? parseInt(index) : index;
        setOrderDetails(dataArray[numericIndex][fieldName]);
      }
    }
  };

  const resetJsonView = async () => {
    setOrderDetails(null);
  }

  const resetPage = async () => {
    setCurrentPage(0);
  }

  return (
    <div style={{ paddingLeft: '20px' }}>
      <div className='mainPageView'>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5%' }}>
          <div className='buttonsView'>
            <input
              type="text"
              value={loginId}
              onChange={handleLoginIdChange}
              placeholder="Enter Login ID"
              className='enter-value-from-user'
            />
            <div className='allButtons'>
              {fetchDataSection('User Data', fetchUserData, userData)}
              {fetchDataSection('Outlet Data', toggleOutletSection, outletData)}
              {anchorElList && (
                <ListDropdown
                  listData={outletData}
                  id={id}
                  open={open}
                  anchorEl={anchorElList}
                  setAnchorEl={setAnchorElList}
                  onSelect={handleOutletSelect}
                />
              )}
              {fetchDataSection('Outlet Product Info Data', fetchProductInfoData, productInfoData)}
              {fetchDataSection('Analytics Data', fetchAnalytics, analyticsData)}
              {fetchDataSection('Delivery PJP', fetchdeliveryPJP, deliveryPjp)}
              {fetchDataSection('Attendance Data', fetchAttendance, attendanceData)}
              {fetchDataSection('Invoice Collection', fetchInvoiceCollection, invoiceCollection)}
              {fetchDataSection('Orders Data', toggleOrdersSection, ordersData)}
              {ordersAnchorEl && (
                <CalenderFilter
                  id={ordersOpen ? 'orders-popover' : undefined}
                  open={ordersOpen}
                  anchorEl={ordersAnchorEl}
                  setAnchorEl={setOrdersAnchorEl}
                  loginId={loginId}
                  setData={setOrdersData}
                  dataType="orders"
                />
              )}
              {fetchDataSection('Sales Data', toggleSalesSection, salesData)}
              {salesAnchorEl && (
                <CalenderFilter
                  id={salesOpen ? 'sales-popover' : undefined}
                  open={salesOpen}
                  anchorEl={salesAnchorEl}
                  setAnchorEl={setSalesAnchorEl}
                  loginId={loginId}
                  setData={setSalesData}
                  dataType="sales"
                />
              )}
              {fetchDataSection('Generic Object Data', toggleGenericObject, genericObjectData)}
              {anchorElListGenericObject && (
                <ListDropdown
                  listData={genericObjectData}
                  id={id}
                  open={open}
                  anchorEl={anchorElListGenericObject}
                  setAnchorEl={setAnchorElListGenericObject}
                                    onSelect={handleGenericObjectSelect}
                                  />
                                )}
                {fetchDataSection('Enrichment Info', fetchEnrichmentInfo, enrichmentInfo)}
                {fetchDataSection('Transformer Info', fetchTransformerInfo,transformerInfo)}
                {fetchDataSection('Query Info', fetchQueryInfo,queryInfo)}
                              </div>
                            </div>

                            <div className='buttonsView'>
                              <input
                                type="text"
                                value={productCode}
                                onChange={handleProductCodeChange}
                                placeholder="Enter SKU/Batch Code"
                                className='enter-value-from-user'
                              />
                              {fetchDataSection('Product Data', fetchProductData, productData)}
                              {fetchDataSection('Stock Data', fetchStockData, stockData)}
                              {fetchDataSection('Pricing Data', fetchProductMetadata, pricingData)}
                            </div>
                            <div className='buttonsView'>
                              <input
                                type="text"
                                value={schemeId}
                                onChange={handleSchemeIdChange}
                                placeholder="Enter SchemeId"
                                className='enter-value-from-user'
                              />
                              {fetchDataSection('SchemeDef Data', fetchSchemesDef, schemeDefData)}
                              {fetchDataSection('SchemeCal Data', fetchSchemesCal, schemeCalData)}
                              {fetchDataSection('SchemeMustBuy Data', fetchSchemesMustBuy, schemeMustBuyData)}
                              {fetchDataSection('SchemeOutBif Data', fetchSchemesOutBif, schemeOutBifData)}
                              {fetchDataSection('SchemeProBif Data', fetchSchemesProBif, schemeProBifData)}
                            </div>
                          </div>
                          <div className="scrollable-frame">
                            {currentView === 'User Data' && (
                              <>
                                {!userData || !Array.isArray(userData) || userData.length === 0 ? NoDataDisplay : (
                                  <Data
                                    resetPage={resetPage}
                                    setCount={resetPageNoAndSetCount}
                                    currentPage={currentPage}
                                    rowsPerPage={rowsPerPage}
                                    data={orderDetails ? orderDetails : userData}
                                    downloadExcel={downloadExcel}
                                    expandJsonView={expandJsonView}
                                    resetView={resetJsonView}
                                  />
                                )}
                              </>
                            )}
                            {currentView === 'Outlet Data' && (
                              <>
                                {!outletDetails || !Array.isArray(outletDetails) || outletDetails.length === 0 ? NoDataDisplay : (
                                  <Data
                                    resetPage={resetPage}
                                    setCount={resetPageNoAndSetCount}
                                    currentPage={currentPage}
                                    rowsPerPage={rowsPerPage}
                                    data={outletDetails}
                                    downloadExcel={downloadExcel}
                                    expandJsonView={expandJsonView}
                                    resetView={resetJsonView}
                                  />
                                )}
                              </>
                            )}

                            {currentView === 'Product Data' && (
                              <>
                                {!productData || !Array.isArray(productData) || productData.length === 0 ? NoDataDisplay : (
                                  <Data
                                    resetPage={resetPage}
                                    setCount={resetPageNoAndSetCount}
                                    currentPage={currentPage}
                                    rowsPerPage={rowsPerPage}
                                    data={productData}
                                    downloadExcel={downloadExcel}
                                    expandJsonView={expandJsonView}
                                    resetView={resetJsonView}
                                  />
                                )}
                              </>
                            )}

                            {currentView === 'SchemeDef Data' && schemeDefData && (
                              <>
                                {!schemeDefData || schemeDefData.length === 0 ? NoDataDisplay : (
                                  <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={schemeDefData} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                )}
                              </>
                            )}

                            {currentView === 'SchemeCal Data' && schemeCalData && (
                              <>
                                {!schemeCalData || schemeCalData.length === 0 ? NoDataDisplay : (
                                  <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={schemeCalData} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                )}
                              </>
                            )}

                            {currentView === 'SchemeMustBuy Data' && schemeMustBuyData && (
                              <>
                                {!schemeMustBuyData || schemeMustBuyData.length === 0 ? NoDataDisplay : (
                                  <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={schemeMustBuyData} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                )}
                              </>
                            )}

                            {currentView === 'SchemeOutBif Data' && schemeOutBifData && (
                              <>
                                {!schemeOutBifData || schemeOutBifData.length === 0 ? NoDataDisplay : (
                                  <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={schemeOutBifData} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                )}
                              </>
                            )}

                            {currentView === 'SchemeProBif Data' && schemeProBifData && (
                              <>
                                {!schemeProBifData || schemeProBifData.length === 0 ? NoDataDisplay : (
                                  <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={schemeProBifData} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                )}
                              </>
                            )}

                            {currentView === 'Delivery PJP' && deliveryPjp && (
                              <>
                                {!deliveryPjp || deliveryPjp.length === 0 ? NoDataDisplay : (
                                  <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={deliveryPjp} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                )}
                              </>
                            )}

                            {currentView === 'Stock Data' && stockData && (
                              <>
                                {!stockData || stockData.length === 0 ? NoDataDisplay : (
                                  <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={stockData} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                )}
                              </>
                            )}

                            {currentView === 'Outlet Product Info Data' && productInfoData && (
                              <>
                                {!productInfoData || productInfoData.length === 0 ? NoDataDisplay : (
                                  <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={orderDetails ? orderDetails : productInfoData} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                )}
                              </>
                            )}
                            {currentView === 'Enrichment Info' && enrichmentInfo && (
                                                          <>
                                                            {!enrichmentInfo || enrichmentInfo.length === 0 ? NoDataDisplay : (
                                                              <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={orderDetails ? orderDetails : enrichmentInfo} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                                            )}
                                                          </>
                                                        )}
                            {currentView === 'Transformer Info' && transformerInfo && (
                                                                                      <>
                                                                                        {!transformerInfo || transformerInfo.length === 0 ? NoDataDisplay : (
                                                                                          <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={orderDetails ? orderDetails : transformerInfo} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                                                                        )}
                                                                                      </>
                                                                                    )}
                            {currentView === 'Query Info' && queryInfo && (
                                                                                                                  <>
                                                                                                                    {!queryInfo || queryInfo.length === 0 ? NoDataDisplay : (
                                                                                                                      <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={orderDetails ? orderDetails : queryInfo} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                                                                                                    )}
                                                                                                                  </>
                                                                                                                )}

                            {currentView === 'Pricing Data' && pricingData && (
                              <>
                                {!pricingData || pricingData.length === 0 ? NoDataDisplay : (
                                  <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={pricingData} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                )}
                              </>
                            )}

                            {currentView === 'Analytics Data' && (
                              <>
                                {!analyticsData || !Array.isArray(analyticsData) || analyticsData.length === 0 ? NoDataDisplay : (
                                  <Data
                                    resetPage={resetPage}
                                    setCount={resetPageNoAndSetCount}
                                    currentPage={currentPage}
                                    rowsPerPage={rowsPerPage}
                                    data={analyticsData}
                                    downloadExcel={downloadExcel}
                                    expandJsonView={expandJsonView}
                                    resetView={resetJsonView}
                                  />
                                )}
                              </>
                            )}

                            {currentView === 'Attendance Data' && attendanceData && (
                              <>
                                {!attendanceData || attendanceData.length === 0 ? NoDataDisplay : (
                                  <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={attendanceData} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                )}
                              </>
                            )}

                            {currentView === 'Invoice Collection' && (
                              <>
                                {!invoiceCollection || !Array.isArray(invoiceCollection) || invoiceCollection.length === 0 ? NoDataDisplay : (
                                  <Data
                                    resetPage={resetPage}
                                    setCount={resetPageNoAndSetCount}
                                    currentPage={currentPage}
                                    rowsPerPage={rowsPerPage}
                                    data={invoiceCollection}
                                    downloadExcel={downloadExcel}
                                    expandJsonView={expandJsonView}
                                    resetView={resetJsonView}
                                  />
                                )}
                              </>
                            )}

                            {currentView === 'Orders Data' && ordersData && (
                              <>
                                {!ordersData || ordersData.length === 0 ? NoDataDisplay : (
                                  <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={orderDetails ? orderDetails : ordersData} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                )}
                              </>
                            )}

                            {currentView === 'Sales Data' && salesData && (
                              <>
                                {!salesData || salesData.length === 0 ? NoDataDisplay : (
                                  <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={orderDetails ? orderDetails : salesData} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                )}
                              </>
                            )}

                            {currentView === 'Generic Object Data' && genericObjectData && (
                              <>
                                {!genericObjectDetails || (Array.isArray(genericObjectDetails) && genericObjectDetails.length === 0) ? NoDataDisplay : (
                                  <Data resetPage={resetPage} setCount={resetPageNoAndSetCount} currentPage={currentPage} rowsPerPage={rowsPerPage} data={genericObjectDetails} downloadExcel={downloadExcel} expandJsonView={expandJsonView} resetView={resetJsonView} />
                                )}
                              </>
                            )}
                          </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'right' }}>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            component="div"
                            count={count}
                            rowsPerPage={rowsPerPage}
                            page={currentPage}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelDisplayedRows={({ count, page }) => `Page: ${count === 0 ? 0 : page + 1} | Total Records: ${count}`}
                          />
                        </div>
                      </div>
                    );
                  };

                  export default DataValidation;